let cache: Record<string, any> | null = null
let env: string | null = null
const listeners: Array<() => void> = []

export async function loadRuntime() {
  if (cache) return cache
  try {
    const res = await fetch('/runtime-config.json')
    const json = await res.json()
    cache = json
    env = localStorage.getItem('APP_ENV') || 'development'
    return cache
  } catch (e) {
    console.warn('loadRuntime failed', e)
    cache = {}
    return cache
  }
}

export function getEnvs() {
  return cache ? Object.keys(cache) : ['development']
}

export function getRuntimeConfig() {
  const current = env || localStorage.getItem('APP_ENV') || 'development'
  return (cache && cache[current]) || { API_BASE: import.meta.env.VITE_API_BASE }
}

export function setEnv(nextEnv: string) {
  env = nextEnv
  localStorage.setItem('APP_ENV', nextEnv)
  listeners.forEach(cb => cb())
}

export function currentEnv() {
  return env || localStorage.getItem('APP_ENV') || 'development'
}

export function onEnvChange(cb: () => void) {
  listeners.push(cb)
}
